/**
 * KROQ — Duo : deux produits, un seul geste.
 *
 * Un seul appel `/cart/add.js` avec deux `items`. S'il échoue, aucun des
 * deux n'entre au panier : Shopify traite la requête comme un tout. On
 * évite ainsi le demi-panier — un composant ajouté, l'autre non, sans que
 * le client comprenne pourquoi.
 *
 * Le total se recalcule quand une variante change, à partir du prix porté
 * par l'option. Aucune remise n'est appliquée ici : le Duo est une
 * commodité d'achat, pas une offre. Si une remise arrive un jour, elle
 * viendra de l'admin Shopify, comme celle des packs.
 */
(function () {
  'use strict';

  const ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root
    ? Shopify.routes.root : '/') + 'cart/add.js';

  function centimes(duo) {
    let total = 0;
    duo.querySelectorAll('.kroq-duo__info').forEach(function (info) {
      const aff = info.querySelector('.kroq-duo__price');
      total += aff ? Number(aff.dataset.prix || 0) : 0;
    });
    return total;
  }

  /**
   * Résout la variante à partir des menus d'options d'un composant.
   *
   * Un menu par option : il faut recomposer la combinaison pour retrouver
   * l'identifiant de variante, que Shopify seul connaît. Le champ caché
   * est vidé si la combinaison n'existe pas ou n'est plus disponible —
   * `ajouter` refuse alors plutôt que d'envoyer un identifiant mort.
   */
  function resoudre(info) {
    const source = info.querySelector('[data-kroq-duo-variants]');
    const champ = info.querySelector('[data-kroq-duo-variant]');
    const aff = info.querySelector('.kroq-duo__price');
    if (!source || !champ || !aff) return;

    let variantes = [];
    try { variantes = JSON.parse(source.textContent); } catch (e) { return; }

    const menus = [...info.querySelectorAll('[data-kroq-duo-option]')];
    const choix = menus.map(function (m) { return m.value; });

    // Une valeur qu'aucune variante disponible ne porte est barrée, quelle
    // que soit l'autre option : le client voit tout de suite ce qui reste.
    menus.forEach(function (menu) {
      const pos = Number(menu.dataset.position);
      [...menu.options].forEach(function (opt) {
        opt.disabled = !variantes.some(function (v) {
          return v.d && v.o[pos] === opt.value;
        });
      });
    });

    const trouvee = variantes.find(function (v) {
      return v.o.length === choix.length && v.o.every(function (val, i) {
        return val === choix[i];
      });
    });

    if (trouvee && trouvee.d) {
      champ.value = trouvee.id;
      aff.dataset.prix = trouvee.p;
      aff.textContent = formater(trouvee.p);
    } else {
      champ.value = '';
      aff.dataset.prix = 0;
      aff.textContent = aff.dataset.indispo || 'Momentanément indisponible';
    }
  }

  function formater(c) {
    // Format français, indépendant du money_format de la boutique.
    return (c / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function majTotal(duo) {
    const cible = duo.querySelector('[data-kroq-duo-total]');
    if (!cible) return;
    const t = centimes(duo);
    if (t > 0) cible.textContent = formater(t);
  }

  function signaler(duo, message) {
    const zone = duo.querySelector('[data-kroq-duo-error]');
    if (!zone) return;
    zone.textContent = message || '';
    zone.hidden = !message;
  }

  function suivre(nom, charge) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(nom, charge);
      }
      if (typeof window.clarity === 'function') window.clarity('event', nom.replace(/:/g, '_'));
    } catch (e) { /* le suivi ne casse jamais l'achat */ }
  }

  async function ajouter(duo, bouton) {
    const ids = [...duo.querySelectorAll('[data-kroq-duo-variant]')]
      .map(function (ch) { return Number(ch.value); })
      .filter(Boolean);
    if (ids.length < 2) {
      signaler(duo, 'Cette combinaison n’est pas disponible. Changez de '
        + 'taille ou de coloris.');
      return;
    }

    const corps = { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) };
    const res = await fetch(ROUTE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(corps),
    });
    if (!res.ok) {
      let motif = '';
      try { motif = (await res.json()).description || ''; } catch (e) { /* corps illisible */ }
      throw new Error(motif || 'ajout refusé');
    }

    let panier = null;
    try {
      const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js',
        { headers: { Accept: 'application/json' } });
      if (r.ok) panier = await r.json();
    } catch (e) { /* non bloquant */ }

    // Même événement que le reste du thème : c'est lui qui ouvre le tiroir.
    (bouton || document).dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: panier,
        sourceId: 'kroq-duo',
        data: { source: 'kroq-duo', itemCount: panier ? panier.item_count : null },
      },
    }));

    suivre('kroq_duo_add', {
      duo_id: duo.getAttribute('data-kroq-duo'),
      placement: duo.closest('[data-season]')
        ? duo.closest('[data-season]').getAttribute('data-season') : 'pdp',
    });
  }

  document.addEventListener('change', function (e) {
    const menu = e.target.closest('[data-kroq-duo-option]');
    if (!menu) return;
    const info = menu.closest('.kroq-duo__info');
    if (info) resoudre(info);
    const duo = menu.closest('[data-kroq-duo]');
    if (duo) { majTotal(duo); signaler(duo, ''); }
  });

  document.addEventListener('click', function (e) {
    const bouton = e.target.closest('[data-kroq-duo-add]');
    if (!bouton || bouton.disabled) return;
    const duo = bouton.closest('[data-kroq-duo]');
    if (!duo) return;

    bouton.disabled = true;
    bouton.setAttribute('data-loading', '');
    signaler(duo, '');

    ajouter(duo, bouton)
      .catch(function (err) {
        console.error('[Kroq] duo:', err);
        signaler(duo, err.message
          ? 'Ajout impossible : ' + err.message
          : 'Ajout impossible. Ouvrez les fiches pour réessayer.');
      })
      .finally(function () {
        bouton.disabled = false;
        bouton.removeAttribute('data-loading');
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Le rendu Liquid pose déjà la première variante disponible. Ce premier
    // passage ne sert qu'à barrer les valeurs épuisées, que Liquid ne peut
    // pas croiser entre deux options.
    document.querySelectorAll('.kroq-duo__info').forEach(resoudre);
    document.querySelectorAll('[data-kroq-duo]').forEach(majTotal);
  });
})();
